<template>
  <div>
    <v-dialog v-model="showForm" fullscreen>
      <v-card v-if="showForm">
        <v-toolbar dark color="primary" tabs>
          <v-btn icon dark @click="showForm = !showForm">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t('Mensaje de difusión') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat @click="submit">{{ $t('Save') }}</v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <aru-auto-form
          v-if="configReady"
          v-model="formData"
          :form-configuration="config.form"
          :dismiss-button="true"
          dismiss-text="Close"
          @submit="submit"
          @dismiss="showForm = false"
        ></aru-auto-form>
      </v-card>
    </v-dialog>
    <v-layout row wrap>
      <v-flex xs2>
        <v-btn @click="newBroadcastForm()" color="primary">
          {{ $t('Programar Mensaje') }}
        </v-btn>
      </v-flex>
      <v-flex>
        <aru-search-entity
          v-if="configReady"
          :with-progress-bar="true"
          :page="page"
          :search-config="config.search"
          :entity="entity"
          v-model="items"
          @loading="
            page = 1;
            itemsReady = false;
          "
          @stopLoading="itemsReady = true"
          @meta="setPagination"
        ></aru-search-entity>
      </v-flex>
    </v-layout>

    <div class="v-table__overflow">
      <table class="v-datatable v-table theme--light">
        <thead>
          <tr>
            <th v-for="(field, i) in header" :key="i" :class="getThClass(field)">
              <template v-if="field.value">
                <v-btn
                  class="v-btn-header-datatable"
                  :class="getBtnClass(field)"
                  :color="getOrderThColor(field.value)"
                  flat
                  small
                  @click="orderBy(field.value)"
                >
                  {{ $t(field.text) }}
                  <v-icon>{{ getOrderChevronIcon(field.value) }}</v-icon>
                </v-btn>
              </template>

              <template v-else>
                <v-btn
                  class="v-btn-header-datatable"
                  :class="getBtnClass(field)"
                  disabled
                  :color="getOrderThColor('other')"
                  flat
                  small
                >
                  {{ $t(field.text) }}
                </v-btn>
              </template>
            </th>
          </tr>
        </thead>
        <tbody v-if="readyToList">
          <tr v-for="(entity, i) in items" :key="entity.id">
            <td>{{ entity.title }}</td>
            <td>{{ entity.date | moment('DD/MM/YYYY') }}</td>
            <td>{{ `${entity.date} ${entity.time}` | moment('HH:mm') }}</td>
            <td>{{ entity.group | truncate(20, '...') }}</td>

            <!-- <td>{{entity.updated_at | moment("DD/MM/YYYY")}}</td>
            <td>{{entity.created_at | moment("DD/MM/YYYY")}}</td> -->
            <td class="text-xs-right">
              <v-btn color="error" flat icon @click="deleteEntity(entity, i)">
                <v-icon>mdi-delete-outline</v-icon>
              </v-btn>
              <v-btn color="info" flat icon @click="editEntity(entity, i)">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>

              <!-- <v-menu offset-y>
                <v-btn
                  slot="activator"
                  color="primary"
                  dark
                  flat
                  min-width="100"
                >
                  <template v-if="!loadingEntity[entity.id]">
                    {{ $t('Acciones') }}
                  </template>
                  <v-progress-circular
                    v-if="loadingEntity[entity.id]"
                    indeterminate
                    color="primary"
                  ></v-progress-circular>
                </v-btn>
              </v-menu> -->
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr v-for="i in 15" :key="'mock-table' + i">
            <td v-for="(field, i) in header" :key="i">
              <div class="grey lighten-3" :style="getMockStyle(field)"></div>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="text-xs-center" v-if="showPagination">
        <v-pagination v-model="page" :length="pagination.last_page"></v-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import apiCtrl from '@/services/aru-services/aru-api.service.js';
import AruListMixin from '@/mixins/list/AruListMixin.js';
import AruSearchEntity from '@/components/commons/search/AruSearchEntity';
import AruAutoForm from '@/components/commons/form/AruAutoForm.vue';

export default {
  mixins: [AruListMixin],
  components: {
    AruSearchEntity,
    AruAutoForm,
  },
  data() {
    return {
      showForm: false,
      formData: {},
      header: [
        {
          value: 'title',
          text: 'Título',
          mockWidth: '300px',
        },
        {
          value: 'date',
          text: 'Fecha',
          mockWidth: '50px',
        },
        {
          value: 'time',
          text: 'Hora',
          mockWidth: '50px',
        },
        {
          value: 'group',
          text: 'Grupo',
          mockWidth: '100px',
        },
        {
          value: '',
          text: 'Acciones',
          btnClass: 'pr-4',
          thClass: 'text-xs-right py-0',
          mockAlign: 'right',
        },
      ],
    };
  },
  methods: {
    newBroadcastForm() {
      this.formData = {};
      this.showForm = true;
    },
    submit() {
      if (this.formData.id) {
        this.updateEntity();
      } else {
        this.saveEntity();
      }
    },
    saveEntity() {
      this.savingData = true;
      apiCtrl
        .post('/broadcast-messages', this.formData)
        .then(() => {
          this.getEntities();
          this.showForm = false;
        })
        .catch(() => {
          this.savingData = false;
        });
      console.log(this.formData);
    },
    updateEntity() {
      this.savingData = true;
      apiCtrl
        .put('/broadcast-messages/' + this.formData.id, this.formData)
        .then(() => {
          this.getEntities();
          this.showForm = false;
        })
        .catch(() => {
          this.savingData = false;
        });
      console.log(this.formData);
    },
    getThClass(field) {
      if (field.hasOwnProperty('thClass')) {
        return field.thClass;
      } else {
        return 'text-xs-left py-0';
      }
    },

    getBtnClass(field) {
      if (field.hasOwnProperty('btnClass')) {
        return field.btnClass;
      } else {
        return '';
      }
    },
    getMockStyle(field) {
      const style = {
        width: field.mockWidth ? field.mockWidth : '80px',
        height: field.mockHeight ? field.mockHeight : '15px',
        'border-radius': field.mockRadius ? field.mockRadius : '10px',
        float: field.mockAlign ? field.mockAlign : 'none',
      };
      return style;
    },
    orderBy(field) {
      if (
        this.params.hasOwnProperty('orderBy') &&
        this.params.orderBy === field &&
        this.params.hasOwnProperty('sortedBy')
      ) {
        if (this.params.sortedBy === 'desc') {
          this.$set(this.params, 'orderBy', field);
          this.$set(this.params, 'sortedBy', 'asc');
        } else {
          delete this.params.orderBy;
          delete this.params.sortedBy;
        }
      } else {
        this.$set(this.params, 'orderBy', field);
        this.$set(this.params, 'sortedBy', 'desc');
      }

      this.getEntities();
    },
    editEntity(entity) {
      this.formData = entity;
      this.showForm = true;
    },
    deleteEntity(entity, i) {
      console.log({
        DELETE: entity,
      });

      apiCtrl.delete('/' + this.entity + '/' + entity.id).then(() => {
        this.getEntities();
      });
    },

    getOrderThColor(field) {
      if (this.params.hasOwnProperty('orderBy') && this.params.orderBy === field) {
        return 'primary';
      } else {
        return 'grey';
      }
    },
    getOrderChevronIcon(field) {
      if (
        this.params.hasOwnProperty('orderBy') &&
        this.params.orderBy === field &&
        this.params.hasOwnProperty('sortedBy')
      ) {
        if (this.params.sortedBy === 'asc') {
          return 'mdi-chevron-up';
        } else if (this.params.sortedBy === 'desc') {
          return 'mdi-chevron-down';
        }
      }

      return 'mdi-chevron-right';
    },
  },
};
</script>

<style lang="scss">
.v-btn-header-datatable {
  min-width: 0px;
  margin: 0px;
  padding: 0px;
}
</style>
